import { getConfig } from '../config';

export const API_BASE_URL = getConfig().API_BASE_URL;
export const APP_ORY_URL = getConfig().APP_ORY_URL;
export const SYMPTOMS_URL = `/symptoms`;
export const GUIDES_URL = `/guides`;
export const SYMPTOMS_SURVEY_QUESTIONNAIRES_API_URL = `/questionnaires/symptom-survey`;
export const getSymptomSurveyQuestionnairesUrl = (userId?: string) => `/users/${userId}/questionnaires/symptom-survey`;
export const getSymptomSurveyAnswersUrl = (userId?: string) => `/users/${userId}/questionnaires?type=symptom-survey`;

export const appointmentsUrl = (userId?: string) => `/users/${userId}/appointments`;
export const appointmentUrl = (userId?: string, appointmentId?: string) => `/users/${userId}/appointments/${appointmentId}`;

export const getActiveGearsUrl = (userId: string) => `/users/${userId}/active-gears`;

export const getUserSymptomsUrl = (userId: string) => `/users/${userId}/symptoms`;
export const getAppointmentSymptomsUrl = (userId: string, appointmentId: string) =>
    `/users/${userId}/appointments/${appointmentId}/symptoms`;

export const getMedicationRegimensUrl = (userId: string) => `/users/${userId}/medication-regimens`;
export const getUserMedicationsUrl = (userId: string) => `/users/${userId}/medications`;
export const getAppointmentMedicationsUrl = (userId: string, appointmentId: string) =>
    `/users/${userId}/appointments/${appointmentId}/medications`;

export const getPathTraversalUrl = (userId: string, regionId: string) => `/users/${userId}/regions/${regionId}/paths`;

export const getMarkMyPositionUrl = (userId: string, regionId: string) => `/users/${userId}/regions/${regionId}/position`;

export const getQuestionnaireDataForUserUrl = (userId: string) => `/users/${userId}/questionnaires`;

export const getDrawerUrl = (id: string) => `/stations/${id}/drawer`;

export const getUserRegionUrl = (userId: string, regionId: string) => `/users/${userId}/regions/${regionId}`;

export const getUserUrl = (userId: string) => `/users/${userId}?includeReferencedRegions=true`;

export const whoAmIUrl = () => `/users/whoami`;

export const onboardingQuestionnairesUrl = () => `/questionnaires/onboarding`;

export const createUserQuestionnairesURL = (userID: string) => `/users/${userID}/questionnaires/onboarding`;

export const getMasterRegionsUrl = (query?: string) => `/regions?${query}`;

export const getAssignMapRegionsUrl = (userID: string) => `/users/${userID}/regions`;

export const getRegionFiltersUrl = () => `/regions/filters`;

export const getUnAssignMapRegionsUrl = (userID: string) => `/users/${userID}/regions/unassign`;

export const getRequestMapQuestionnaireUrl = () => `/questionnaires/request-map`;

export const createRequestMapQuestionnaireUrl = (userID: string) => `/users/${userID}/questionnaires/request-map`;

export const extendSessionUrl = (userID: string) => `/users/${userID}/extend-session`;

export const getCareTeamNotesSuggestionQuestionsUrl = () => '/questionnaires/care-team-notes-suggestions';

export const getRegionSymptomsUrl = (userID: string, regionID: string) => `/users/${userID}/regions/${regionID}/symptoms`;

export const getRegionSearchUrl = (words: string[], regionNames: string) =>
    `/regions/search?words=${words.join(',')}&regions=${encodeURIComponent(regionNames)}`;

export const getMapRequestUrl = (userID: string) => `/users/${userID}/requests`;

export const getUserRequestsUrl = (userID: string, _?: { [param: string]: string }) => `/requests?userID=${userID}`;

export const getRegionsWithNameUrl = (userID: string, regionNames: string) =>
    `/users/${userID}/regions?regionNames=${encodeURIComponent(regionNames)}`;

export const createUserProvenancesUrl = (userID: string) => `/users/${userID}/provenances`;

export const getUserProvenancesUrl = (userID: string) => `/users/${userID}/provenances`;

export const createUserUrl = () => '/users';

export const submitRegionFeedbackUrl = (userID: string, regionID: string) => `/users/${userID}/regions/${regionID}/feedback`;
